<h1 mat-dialog-title>
  <p *ngIf="!data.readonly">Create/Edit a Location</p>
  <p *ngIf="data.readonly">Location Details</p>
</h1>
<mat-progress-bar *ngIf="progress"
                  [color]="'primary'"
                  [mode]="'indeterminate'">
</mat-progress-bar>

<div mat-dialog-content>
  <div class="row">
    <div class="col-sm-6 col-xs-12">
      <mat-form-field appearance="standard" style="width: 100%">
        <mat-label>Name</mat-label>
        <input matInput [disabled]="progress || data.readonly" required [(ngModel)]="data.name">
      </mat-form-field>
    </div>
    <div class="col-sm-6 col-xs-12">
      <mat-form-field appearance="standard" style="width: 100%">
        <mat-label>VetSource Location ID</mat-label>
        <input matInput [disabled]="progress || data.editable || data.readonly" required [(ngModel)]="data.vetSourceId">
      </mat-form-field>
    </div>
    <div class="col-sm-6 col-xs-12">
      <mat-form-field appearance="standard" style="width: 100%">
        <mat-label>VetSource Practice Id</mat-label>
        <input matInput [disabled]="progress || data.readonly" type="number" required [(ngModel)]="data.vetSuccessPracticeId">
      </mat-form-field>
    </div>
    <div class="col-sm-6 col-xs-12">
      <mat-form-field appearance="standard" style="width: 100%">
        <mat-label>NetSuite Subsidiary Id</mat-label>
        <input matInput [disabled]="progress || data.readonly" type="number" required [(ngModel)]="data.netSuiteId">
      </mat-form-field>
    </div>
    <div class="col-sm-6 col-xs-12">
      <mat-form-field appearance="standard" style="width: 100%">
        <mat-label>Acquisition date</mat-label>
        <input matInput [disabled]="progress || data.readonly" [formControl]="acquisitionDate" required [matDatepicker]="acquisitionDateId">
        <mat-datepicker-toggle matSuffix [for]="acquisitionDateId"></mat-datepicker-toggle>
        <mat-datepicker #acquisitionDateId></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-sm-6 col-xs-12">
      <mat-form-field appearance="standard" style="width: 100%">
        <mat-label>Start date</mat-label>
        <input matInput [disabled]="progress || data.readonly" [formControl]="startDate" [matDatepicker]="startDateId">
        <mat-datepicker-toggle matSuffix [for]="startDateId"></mat-datepicker-toggle>
        <mat-datepicker #startDateId></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-xs-12">
      <mat-checkbox [disabled]="progress || data.readonly" [(ngModel)]="data.multiLocation">Multi-Location Practice
      </mat-checkbox>
    </div>

    <div class="col-xs-12">
      <mat-checkbox [disabled]="progress || data.readonly" [(ngModel)]="data.active">Activate
      </mat-checkbox>
    </div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Close</button>
  <button mat-button (click)="onSubmit()" *ngIf="!data.readonly" [disabled]="!data.name || !data.vetSourceId || !data.vetSuccessPracticeId || !data.netSuiteId || !acquisitionDate.value" cdkFocusInitial>Submit</button>
</div>
